(function($) {
	//jQuery plugin definition
	$.fn.projectMapsModule = function() {

		var generateMapOptionsObj = function(){
			return {
				region: 'US',
				displayMode: 'regions',  
				resolution: 'provinces',
				backgroundColor: 'transparent',
				datalessRegionColor: "#DEE1EB",
				enableRegionInteractivity: true, 
				legend: "none",
				keepAspectRatio: true,
                tooltip: {
                    trigger: 'none'
                },
				colorAxis: {
					minValue: 0,
					maxValue: 1,
					colors: [
						'#d5d1ff',
						'#ffd8c5',
					]
				}
			}
		}

		var getProjectIdsFromString = function(str){
			return str.length ? str.split(",").map(function(item) {
				return item.trim();
			}) : [];
		}

		var formatStateDataForMap = function(stateData) {
			var mapStateData = [
				['State', 'Value']
			];

			if(stateData.length == 0){
				mapStateData.push([0, 0]);
			}

			stateData.forEach(function(el, i) {
				mapStateData.push([el.state.value, 0]);
			});

			return mapStateData;
		}

		var formatPinsDataForMap = function(pinsData) {
			var result = [
				['Lat', 'Long', 'Value']
			];

			if(pinsData.length == 0){
				result.push([0, 0, 0]);
			}

			pinsData.forEach(function(el, i) {
				result.push([el.pin.lat, el.pin.lng, 0]);
			});

			return result;
		}

		var getPinPositions = function(mapContainer){
			var circles = [];
	
			mapContainer.find('circle').each(function () {
				circles.push({
					left: $(this).offset().left - mapContainer.offset().left,
					top: $(this).offset().top - mapContainer.offset().top,
					fillColor: 'red'
				});
			});
			return circles;
		}

		var highlightSelectedStatePath = function($mainMapContainer, config){
			var $svg = $mainMapContainer.find('svg[aria-label="A chart."]');
			var $cloneContainer = $svg.find('>g>g:eq(0)>g:eq(2)');

			if(config && config.emptyContainer){
				$cloneContainer.html('');
			}else{
				$cloneContainer.html('').append($svg.find('>g>g:eq(0)>g:eq(1)>g>path').clone().css('stroke', '#282828').css('fill', '#ffd8c5'));
			}
		}

		var highlightSelectedPin = function($mainMapContainer, config, $selected){
			if(config && config.removeSelected){
				$mainMapContainer.find('.pin.selected').removeClass('selected');
			}else{
				$mainMapContainer.find('.pin').not($selected).removeClass('selected');
				$selected.addClass('selected');
			}
		}

		var highlightSelectedNonCon = function($nonContinentalWrapper, config, $selected){
			if(config && config.removeSelected){
				$nonContinentalWrapper.find('li.selected').removeClass('selected');
			}else{
				$nonContinentalWrapper.find('li').not($selected).removeClass('selected');
				$selected.addClass('selected');
			}
		}

		var selectStateByIndex = function(index, chart, data, mapOptions){
			for (var i = 0; i < data.getNumberOfRows(); i++) {
				if (i === index) {
					data.setValue(i, 1, 1);
				} else {
					data.setValue(i, 1, 0);
				}
			}
			chart.draw(data, mapOptions);
		}

		var selectPinByIndex = function(index, $mapContainer){
			var filter = '';

			if(index == -1){
				$mapContainer.find('.pin').removeClass('active');
			}else{
				if(Array.isArray(index)){
					index.forEach(function(el, i) {
						filter += ':eq('+el+')';
						if(i !== (index.length - 1)){
							filter += ', ';
						}
					});
				}else{
					filter = ':eq('+index+')';
				}

				var $activePin = $mapContainer.find('.pin').filter(filter);
				$activePin.addClass('active');
				$mapContainer.find('.pin').not($activePin).removeClass('active');
			}
		}

		var selectNonConByIndex = function (index, $wrapper){
			var filter = '';

			if(index == -1){
				$wrapper.find('li').removeClass('active');
			}else{
				if(Array.isArray(index)){
					index.forEach(function(el, i) {
						filter += ':eq('+el+')';
						if(i !== (index.length - 1)){
							filter += ', ';
						}
					});
				}else{
					filter = ':eq('+index+')';
				}

				var $activeNonCon = $wrapper.find('li').filter(filter);
				$activeNonCon.addClass('active');
				$wrapper.find('li').not($activeNonCon).removeClass('active');
			}
		}

		var selectStateByIndex = function(index, stateDataInstance, stateChartInstance, mapOptions){
			for (var i = 0; i < stateDataInstance.getNumberOfRows(); i++) {
				if (Array.isArray(index) ? index.includes(i) : i === index) {
					stateDataInstance.setValue(i, 1, 1);
				} else {
					stateDataInstance.setValue(i, 1, 0);
				}
			}
			stateChartInstance.draw(stateDataInstance, mapOptions);
		}

		//private method definitions here
		var drawStateMap = function(config, callback){
			var chart = new google.visualization.GeoChart(config.mapContainer[0]);
			var data = google.visualization.arrayToDataTable(formatStateDataForMap(config.data));
			
			//draw
			chart.draw(data, config.mapOptions);
			
			callback(chart, data);
		}

		var drawPinsMap = function(config, callback){
			var chart = new google.visualization.GeoChart(config.mapContainer[0]);
			var data = google.visualization.arrayToDataTable(formatPinsDataForMap(config.data));

			//draw
			chart.draw(data, Object.assign({}, config.mapOptions, {displayMode: 'markers'}));

			//remove old pins if applicable
			config.mainMapContainer.find('pin').remove();

			//events
			google.visualization.events.addListener(chart, "ready", function () {
				var pins = getPinPositions(config.mapContainer);

				pins.forEach(function(el, i) {
					var pin = "<div class='pin' style='top:"+el.top+"px;left:"+el.left+"px;' index='"+i+"'></div>";
					config.mainMapContainer.append(pin);
				});

				config.mapContainer.css('visibility', 'hidden').css('z-index', '-10');

				callback(chart, data);
			});
		}

		var drawNonConList = function(config){
			var $listContainer = config.$nonContinentalWrapper.find('ul');
			
			//clean up list
			$listContainer.html('');

			if(config.data.length == 0){
				config.$nonContinentalWrapper.addClass('non-con-is-hidden');
			}else{
				config.$nonContinentalWrapper.removeClass('non-con-is-hidden');
			}

			//fill list
			config.data.forEach(function(el, i) {
				$listContainer.append('<li index="'+i+'"><span>'+el.listItem+'</span></li>');
			});
		}

		var getIndexesBySelectedProjects = function(projectIds, data){
			var result = [];
			data.forEach(function(el, i) {
				var filteredArray = el.projectIds.filter(function(n) {
					return projectIds.indexOf(n) !== -1;
				});
				if(filteredArray.length){
					result.push(i);
				}
			});

			return result;
		}

		var getProjectsById = function(id, projectData){
			var result = [];

			projectData.forEach(function(el){
				if(Array.isArray(id) ? id.includes(el.project_id) : id === el.project_id){
					result.push(el);
				}
			});

			return result;
		}

		var matchesFilters = function(projects, filters){
			var typeMatchesCount = 0;
			var strategyMatchesCount = 0;

			projects.forEach(function(el) {
				if(filters.project_type === el.project_type){
					typeMatchesCount += 1;
				}
				if(filters.strategy_id.length){
					var intersection = el.strategy_types.map(function(a){ return a.term_id}).filter(function(n) {
						return [parseInt(filters.strategy_id)].indexOf(n) !== -1;
					});

					if(intersection.length){
						strategyMatchesCount += 1;
					}
				}else{
					strategyMatchesCount = 1;
				}
			});

			return typeMatchesCount > 0 && strategyMatchesCount > 0;
		}
	
		var filterProjectIds = function(projects, filters){
			var result = [];

			projects.forEach(function(el) {
				var matchesType = filters.project_type ? false : true; //if no filter passed then true by default
				var matchesStrategy = filters.strategy_id ? false : true;

				if(el.strategy_types.map(function(a){ return a.term_id}).includes(parseInt(filters.strategy_id))){
					matchesStrategy = true;
				}

				if(filters.project_type === el.project_type){
					matchesType = true;
				}

				if(matchesStrategy && matchesType){
					result.push(el.project_id);
				}
			});

			return result;
		}

		var filterData = function(mapData, projectData, filters, callback){
			var stateData = [];
			var pinsData = [];
			var nonConData = [];

			mapData.forEach(function(el, i) {
				var projectIds = getProjectIdsFromString(el.project_id);
				var projects = getProjectsById(projectIds, projectData);
				var matches = matchesFilters(projects, filters);

				if(matches){
					if(el.marker_type == 'state'){
						stateData.push({
							state: el.state,
							projectIds: filterProjectIds(projects, filters)
						});
					}else if(el.marker_type == 'pin'){
						pinsData.push({
							pin: el.pin,
							projectIds: filterProjectIds(projects, filters)
						});
					}else if(el.marker_type == 'list_item'){
						nonConData.push({
							listItem: el.list_item,
							projectIds: filterProjectIds(projects, filters)
						});
					}
				}
			});

			callback(stateData, pinsData, nonConData);
		}

		var createStratebyButtons = function(strategies){
			var result = '';
			if(strategies){
				strategies.forEach(function(el){
					result += '<span class="strategy-btn cta-button-link" style="background-color:'+el.color+';">'+el.name+'</span>';
				});
			}
			return result;
		}

		var removeAllCards = function ($cardsContainer) {
			$cardsContainer.html('');
		}

		var showCards = function(projects, $cardsContainer, $cardTemplate, $self){
			if($cardsContainer.hasClass('slick-initialized')) {
				$cardsContainer.slick('unslick');
				$cardsContainer.unbind('afterChange');
			}
			$cardsContainer.html('').addClass('unready');

			projects.forEach(function(el){
				var $clone = $('<div>'+$cardTemplate.html()+'</div>');
				$clone.find('h2').html(el.title);
				$clone.find('p').html(el.description);
				$clone.find('.strategies-container').html(createStratebyButtons(el.strategy_types));
				$clone.find('.cta-btn').html(el.cta? el.cta.title : '').attr('href', el.cta? el.cta.url : '').attr('target', el.cta? el.cta.target : '');
				$cardsContainer.append($clone);
			});

			if(projects.length > 1){
				$cardsContainer.slick({
					arrows: false,
					dots: true,
					infinite: true,
					slidesToShow: 1,
					slidesToScroll: 1
				});

				$cardsContainer.on('afterChange', function(event, slick, currentSlide){
					$self.trigger('cca:render-map-for-active-project', {activeIndex: currentSlide});
				});
			}

			setTimeout(function(){
				$cardsContainer.removeClass('unready').addClass('ready');
			}, 250);
		}

		var highlightMapElements = function(config, selectedType){
			if(selectedType === 'pin'){
				highlightSelectedPin(config.$mainMapContainer, false, config.$pin);
				highlightSelectedStatePath(config.$mainMapContainer, {emptyContainer: true});
				highlightSelectedNonCon(config.$nonContinentalWrapper, {removeSelected: true});
			}else if(selectedType === 'state'){
				highlightSelectedPin(config.$mainMapContainer, {removeSelected: true});
				highlightSelectedStatePath(config.$mainMapContainer);
				highlightSelectedNonCon(config.$nonContinentalWrapper, {removeSelected: true});
			}else if(selectedType === 'non-continental'){
				highlightSelectedPin(config.$mainMapContainer, {removeSelected: true});
				highlightSelectedStatePath(config.$mainMapContainer, {emptyContainer: true});
				highlightSelectedNonCon(config.$nonContinentalWrapper, false, config.$nonCon);
			}
		}

		//for each matched elements
		return this.each(function() {
			var $self = $(this);
			var $mainMapContainer = $self.find('[main-map-container]');
			var $pinsMapContainer = $self.find('[pins-map-container]');
			var $cardsContainer = $self.find('.project-card-wrapper > .slider-wrapper');
			var $cardTemplate = $self.find('#project-card-template');
			var $nonContinentalWrapper = $self.find('.non-continental-wrapper');
			var moduleData = JSON.parse($self.attr('cca-data') || '{}');
			var mapOptions = generateMapOptionsObj();
			var $typeFilterOptions = $self.find('.content-type-filters li a');
			var $strategyFilter = $self.find('.category-filter-container > select');
			var stateData = [];
			var stateChartInstance = {}; //geochart instance
			var stateDataInstance = {}; //geochart data instance
			var pinsData = [];
			var pinsChartInstance = {}; //geochart instance
			var pinsDataInstance = {}; //geochart data instance
			var activeProjectArray = {};
			var nonConData = {};
			var filters = {
				project_type : 'current',
				strategy_id: ''
			};

			$self.on('cca:initialize-map', function(){
				$nonContinentalWrapper.removeClass('is-initialized');
				stateData = [];
				pinsData = [];
				removeAllCards($cardsContainer);

				//show empty state card
				showCards([{
					title: 'Explore Our Work',
					description: "From projects with individual systems to nationwide initiatives, we're helping higher education leaders align policy, perspective and practice in service to a more equitable student journey. Click a dot or state on the map to learn more."
				}], $cardsContainer, $cardTemplate, $self);

				filterData(moduleData.map_markers,moduleData.projects, filters, function(filteredStateData, filteredPinsData, filteredNonConData){
					stateData = filteredStateData;
					pinsData = filteredPinsData;
					nonConData = filteredNonConData;
				});

				drawStateMap({
					self : $self,
					mapOptions: mapOptions,
					mapContainer: $mainMapContainer,
					data: stateData,
				}, function(chartInstance, dataInstance){
					stateChartInstance = chartInstance;
					stateDataInstance = dataInstance;
				});
	
				drawPinsMap({
					mainMapContainer: $mainMapContainer,
					mapContainer: $pinsMapContainer,
					mapOptions: mapOptions,
					data: pinsData
				}, function(chartInstance, dataInstance){
					pinsChartInstance = chartInstance;
					pinsDataInstance = dataInstance;
				});

				drawNonConList({
					$nonContinentalWrapper : $nonContinentalWrapper,
					data: nonConData
				});

				//set up event for stateChart
				if(stateChartInstance.selectEvent){
					google.visualization.events.removeListener(stateChartInstance.selectEvent);
				}
				stateChartInstance.selectEvent = google.visualization.events.addListener(stateChartInstance, 'select', function () {
					var selectedStateIndex = stateChartInstance.getSelection()[0].row;
					activeProjectArray = stateData[selectedStateIndex].projectIds;

					$self.trigger('cca:render-map-for-active-project', {activeIndex: 0});

					/**
					 * Highlight correct elements on map
					 */
					 highlightMapElements({
						$mainMapContainer: $mainMapContainer,
						$nonContinentalWrapper : $nonContinentalWrapper
					 }, 'state');

					//show card carousel
					showCards(getProjectsById(stateData[selectedStateIndex].projectIds, moduleData.projects), $cardsContainer, $cardTemplate, $self);
				});
				
				$nonContinentalWrapper.addClass('is-initialized');
			});

			$self.on('cca:render-map-for-active-project', function(ev, config){
				var stateIndexes = getIndexesBySelectedProjects(activeProjectArray[config.activeIndex], stateData);
				var pinsIndexes = getIndexesBySelectedProjects(activeProjectArray[config.activeIndex], pinsData);
				var nonConIndexes = getIndexesBySelectedProjects(activeProjectArray[config.activeIndex], nonConData);
				selectPinByIndex(pinsIndexes, $mainMapContainer);
				selectStateByIndex(stateIndexes, stateDataInstance, stateChartInstance, mapOptions);
				selectNonConByIndex(nonConIndexes, $nonContinentalWrapper);
			});

			$mainMapContainer.on('click', '.pin', function(){
				var $clickedPin = $(this);
				var pinIndex = $clickedPin.attr('index');
				activeProjectArray = pinsData[pinIndex].projectIds;

				$self.trigger('cca:render-map-for-active-project', {activeIndex: 0});

				/**
				 * Highlight correct elements on map
				 */
				highlightMapElements({
					$mainMapContainer: $mainMapContainer,
					$pin: $clickedPin,
					$nonContinentalWrapper : $nonContinentalWrapper
				}, 'pin');

				//show card carousel
				showCards(getProjectsById(pinsData[pinIndex].projectIds, moduleData.projects), $cardsContainer, $cardTemplate, $self);
			});

			$nonContinentalWrapper.on('click', 'li', function () {
				var $clickedNonCon = $(this);
				var nonConIndex = $clickedNonCon.attr('index');
				activeProjectArray = nonConData[nonConIndex].projectIds;

				$self.trigger('cca:render-map-for-active-project', {activeIndex: 0});

				highlightMapElements({
					$mainMapContainer: $mainMapContainer,
					$nonCon: $clickedNonCon,
					$nonContinentalWrapper : $nonContinentalWrapper
				}, 'non-continental');

				//show card carousel
				showCards(getProjectsById(nonConData[nonConIndex].projectIds, moduleData.projects), $cardsContainer, $cardTemplate, $self);

			});

			//initialize module
			google.charts.setOnLoadCallback(function(){
				$self.trigger('cca:initialize-map');

				//create trigger to resizeEnd event     
				$(window).resize(function() {
					if(this.resizeTO) clearTimeout(this.resizeTO);
					this.resizeTO = setTimeout(function() {
						$(this).trigger('resizeEnd');
					}, 350);
				});

				//redraw graph when window resize is completed  
				$(window).on('resizeEnd', function() {
					$self.trigger('cca:initialize-map');
				});
			});

			/**
			 * MODULE FILTERS
			 */
			$strategyFilter.on('change', function(){
				var selected = $strategyFilter.find('option:selected').val();
				if(filters.strategy_id !== selected){
					filters.strategy_id = selected;
					$self.trigger('cca:initialize-map');
				}
			});

			$typeFilterOptions.on('click', function(){
				var $this = $(this);
				var selected = $this.attr('project-type');

				$this.addClass('selected');
				$typeFilterOptions.not($this).removeClass('selected');

				if(filters.project_type !== selected){
					filters.project_type = selected;
					$self.trigger('cca:initialize-map');
				}
			});
		});
	}

	$(document).ready(function() {
		var $projectMapsModule = $('.projects-map-module');
		if($projectMapsModule.length){
			window.loadScript('//www.google.com/jsapi?ext.js', 'google-jsapi', function() {
				google.load('visualization', '1.0', {
					packages: ['geochart'],
					callback: function() {
						$projectMapsModule.projectMapsModule();
					}
				});
			})
		}
	});
})(jQuery);